exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.logs .main-column[data-v-396a05e4] {\n  position: relative;\n}\n.white_bg[data-v-396a05e4] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.5);\n}\ndiv.logs .board.border-none[data-v-396a05e4] {\n  margin-top: 5px;\n  margin-bottom: 15px;\n}\ndiv.logs .user-basic-data .data2[data-v-396a05e4] {\n  padding-top: 5px;\n  padding-top: 5px;\n}", ""]);

// exports
